import { Button } from "@circleco/compass/components/Button";

import { t } from "@/i18n-js/instance";

interface CancelButtonProps {
  onClick: () => void;
}

export const CancelButton = ({ onClick }: CancelButtonProps) => (
  <Button variant="outline" size="md" onClick={onClick}>
    {t("quick_post.scheduled_post_ui.cancel")}
  </Button>
);
